var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcode-share"},[_c('div',{staticClass:"qrcode-box"},[_c('span',{staticClass:"qrcode-name"},[_vm._v("停车优惠券")]),_vm._m(0),_c('div',{ref:"qrCodeUrl",staticClass:"qrcode-img"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"des"},[_vm._v("出口将此码放到扫码枪前扫描"),_c('br'),_vm._v("可抵扣相应的停车费")])
}]

export { render, staticRenderFns }